import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import APIList, { APIListWrapper } from '../components/APIList'
import DownLoadIcon from '../asset/DownLoadIcon'
import { RECLineChart } from '../components/graph/RECLineChart'
import { gql, useQuery } from '@apollo/client'
import { handleAPIRequest } from '../util/getAPI'

//#region styled-components
const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
  border-radius: 8px;
  box-shadow: 0px 4px 16px 0px #00000029;
  overflow: hidden;
`

const Header = styled.div`
  padding: 16px 24px;
  background: #373a40;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  flex-shrink: 0;
`

const Title = styled.div`
  font-family: SUIT;
  font-size: 22px;
  font-weight: 700;
  color: #ffffff;
`

const BodyWrapper = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  padding: 24px;
  background-color: #fff;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  overflow: hidden;
`

const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  min-height: 0;
  gap: 16px;
`

const GraphBox = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
`

const Bottom = styled.div`
  flex-shrink: 0;
  display: flex;
  gap: 24px;
  justify-content: center;
`

const ButtonBox = styled.div`
  display: flex;
  padding: 8px;
  border-radius: 4px;
  gap: 4px;
  align-items: center;
  cursor: pointer;
`

const ButtonText = styled.div`
  font-family: SUIT;
  font-size: 12px;
  font-weight: 500;
  color: #4d4d4d;
`

export const findAllRECGQL = gql`
  query findAllREC {
    findAllREC {
      year
      data {
        date
        landAvgPrc
        jejuAvgPrc
      }
    }
  }
`

export const DataREC = () => {
  const { data: OriginRecData, loading, error } = useQuery(findAllRECGQL)
  const [recData, setRecData] = useState<any[]>([])
  const [selected, setSelected] = useState<string | null>(null)

  useEffect(() => {
    if (OriginRecData) {
      const recData: any = Object.values(OriginRecData)[0] || []
      setRecData(recData)
    }
  }, [OriginRecData])

  const [filteredData, setFilteredData] = useState<any[]>([])

  useEffect(() => {
    if (selected && recData.length > 0) {
      const filtered = recData
        .filter((v: any) => String(v.year) === String(selected))
        .map((v: any) => v.data)
        .flat()
        .sort(
          (a: any, b: any) =>
            new Date(a.date).getTime() - new Date(b.date).getTime()
        ) // 날짜순 정렬

      setFilteredData(filtered)
    }
  }, [selected, recData])

  if (loading) return <p>Loading...</p>
  if (error) return <p>Error : {error.message}</p>

  const handleDownload = () => {
    if (!selected || filteredData.length === 0) return

    const escapeCsv = (value: string | number | null | undefined) =>
      `"${String(value ?? '').replace(/"/g, '""')}"`
    const formatDateOnly = (value: string) => {
      if (!value) return ''
      if (value.includes('T')) return value.split('T')[0]
      return value.substring(0, 10)
    }

    const header = '날짜,육지,제주'
    const rows = filteredData.map((item: any) =>
      [
        escapeCsv(formatDateOnly(String(item.date))),
        escapeCsv(item.landAvgPrc),
        escapeCsv(item.jejuAvgPrc),
      ].join(',')
    )
    const csvContent = [header, ...rows].join('\n')

    const blob = new Blob(['\ufeff', csvContent], {
      type: 'text/csv;charset=utf-8;',
    })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = `rec-${selected}.csv`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }

  return (
    <>
      <APIListWrapper>
        <APIList
          dataList={recData && recData.map((v: any) => v.year)}
          setSelected={setSelected}
          apiFunc={() => handleAPIRequest('TODO')}
          noFile
          noApi
        />
      </APIListWrapper>
      <ContentWrapper>
        <Header>
          <Title>현물 REC</Title>
        </Header>
        <BodyWrapper>
          {selected && (
            <Body>
              <GraphBox>
                <RECLineChart height="100%" width="100%" data={filteredData} />
              </GraphBox>
              <Bottom>
                <ButtonBox onClick={handleDownload}>
                  <DownLoadIcon />
                  <ButtonText>다운로드</ButtonText>
                </ButtonBox>
                {/* <ButtonBox>
                  <DeleteIcon />
                  <ButtonText>삭제</ButtonText>
                </ButtonBox> */}
              </Bottom>
            </Body>
          )}
        </BodyWrapper>
      </ContentWrapper>
    </>
  )
}
